<template>
  <section class="loyalty defaultSectionMargins defaultSectionPaddings">
    <div class="container--Medium">
      <h2 v-text="data?.title" />

      <div v-if="levelsOrdered" class="loyalty__List">
        <div v-for="(item, index) in levelsOrdered" class="loyalty__ListItem" :class="{'isPremium': index === levelsOrdered.length - 1, 'isActive': index === currentLevelIndex}">
          <div class="loyalty__ItemTop">
            <div>
              <h3 v-text="item.name" />
              <p>
                <template v-if="index !== levelsOrdered.length - 1">
                  <span>{{ item.points_from }} - {{ $t('pointsPlural', item.points_to) }}</span>
                </template>
                <template v-else>
                  <span>{{ $t('pointsPage.moreThenPoints', item.points_from) }}</span>
                </template>
              </p>
            </div>

            <div v-if="!isLoyaltyLandingPage" class="loyalty__Icon">
              <Icon name="check" />
              <Icon name="padlock" />
            </div>
          </div>

          <div class="loyalty__ItemFeatures">
            <div v-for="feature in item.features" class="loyalty__Feature">
              <div>
                <Flare :srcset="feature.image" width="100" :alt="feature.image" />
              </div>
              <p v-text="feature.description" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="isLoyaltyLandingPage" class="loyalty__Buttons">
        <Button type="nuxt-link" :to="link('Registration')" medium>{{ $t('join') }}</Button>
      </div>
    </div>
  </section>
</template>

<script setup>
  const { link } = useSetup();
  const { page } = usePage();
  const { user: userData } = useAuth();

  defineProps({
    data: {},
  });

  const userPoints = userData.value?.loyalty?.cumulative_points || 0;
  const levelsOrdered = computed(() => page?.value?.loyalty_levels?.sort((a, b) => a.points_to - b.points_to));
  const currentLevelIndex = computed(() => levelsOrdered.value.findIndex(level => level.points_to >= userPoints));
  const isLoyaltyLandingPage = computed(() => page.value.meta.type.includes('LoyaltyPage'));
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_loyalty.scss');
</style>